
import React, { useState } from "react";
import "./Share.css";
import MinimalNavbar from "./MinimalNavbar";
import "./styles/backgrounds.css";


const Share = () => {
  const [newsletterSubscribed, setNewsletterSubscribed] = useState(false);
  const [email, setEmail] = useState("");

const [sending, setSending] = useState(false);
const [sent, setSent] = useState(false);
const [errorMsg, setErrorMsg] = useState("");

const onSubmit = async (e) => {
  e.preventDefault();
  setSending(true);
  setSent(false);
  setErrorMsg("");
  try {
    const form = e.currentTarget;
    const data = new FormData(form);
    const res = await fetch("https://formsubmit.co/ajax/paul.lanouguere@gmail.com", {
      method: "POST",
      body: data,
    });
    if (!res.ok) throw new Error("Envoi impossible. Réessaie dans un instant.");
    form.reset();
    setSent(true);
  } catch (err) {
    setErrorMsg(err.message || "Une erreur est survenue.");
  } finally {
    setSending(false);
  }
};



  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    if (!email) {
      alert("Veuillez entrer une adresse email.");
      return;
    }
    setNewsletterSubscribed(true);
  };

  return (
    <>
      <div className="navbar-container">
        <MinimalNavbar />
      </div>
<div className="page-background other-background">

        <div className="share-grid-wrapper">
          <div className="share-grid">
            <div className="share-bloc">
              <h1 className="share-title">PARTAGE UN LIVRE</h1>
              <p className="share-subtext">
                Chaque suggestion enrichit notre collection pour tous les lecteurs 📚<br />
                Merci pour ton aide !
              </p>
              <form onSubmit={onSubmit} className="share-form">
                <input
                  type="text"
                  name="Titre"
                  placeholder="Titre du livre"
                  required
                />
                <input
                  type="text"
                  name="Auteur"
                  placeholder="Auteur (facultatif)"
                />
                <textarea
                  name="Raison"
                  placeholder="Pourquoi recommandes-tu ce livre ?"
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Ton email (facultatif)"
                                  />
                <input type="hidden" name="_captcha" value="false" />
                <input type="hidden" name="_next" value="https://www.monprochainlivre.fr/merci" />
                <button type="submit" className="share-button" disabled={sending}>
                  {sending ? "Envoi en cours…" : "Envoyer"}
                </button>
                {sent && <p className="success" role="status" style={{ marginTop: 8 }}>
                      Merci ! Ta suggestion a bien été envoyée ✅
                      </p>}
                    {errorMsg && <p className="error" role="alert" style={{ marginTop: 8 }}>
                    {errorMsg}
                  </p>}
              </form>
            </div>
            
          </div>
        </div>
      </div>
    </>
  );
};

export default Share;
